import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconRegistry } from '@angular/material/icon';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterModule, Event, NavigationEnd } from '@angular/router';

import { ApplicationFeatures, ApplicationFeaturesAvailabilityToken } from '@portal/shared/utils';

import { CacheControlService } from '@portal/core/utils';

@Component({
    imports: [RouterModule],
    selector: 'sp-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    readonly routeConfigLoader: boolean = inject(ApplicationFeaturesAvailabilityToken)[ApplicationFeatures.ROUTE_CONFIG_LOADER];
    private readonly _router: Router = inject(Router);
    private readonly _cacheControlService: CacheControlService = inject(CacheControlService);
    private readonly _matIconReg: MatIconRegistry = inject(MatIconRegistry);
    private readonly _destroyRef: DestroyRef = inject(DestroyRef);

    readonly $routerLoading: WritableSignal<boolean> = signal<boolean>(false);

    ngOnInit(): void {
        this._matIconReg.setDefaultFontSetClass('material-symbols-outlined');

        this._addRouterListener();
    }

    private _addRouterListener(): void {
        if (!this.routeConfigLoader) {
            return;
        }

        this._router.events.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((event: Event) => {
            switch (true) {
                case event instanceof RouteConfigLoadStart:
                    this.$routerLoading.set(true);
                    return;
                case event instanceof RouteConfigLoadEnd:
                    this.$routerLoading.set(false);
                    return;
                case event instanceof NavigationEnd:
                    this._cacheControlService.checkVersion();
            }
        });
    }
}
